import EventTreeVertex from '../EventTreeVertex';
import EventTreeTransferGateVertexValue from "./EventTreeTransferGateVertexValue";
import {mxConstants, mxCylinder, mxGeometry, mxUtils} from "mxgraph-js";

class EventTreeTransferGateVertex extends EventTreeVertex {

  static SHAPE_KEY = 'esd-transfer-gateTypes';

  /**
   * @return {() => void}
   */
  static getShape(): () => void {
    function EventTreeTransferGateVertexShape() { mxCylinder.call(this); }
    mxUtils.extend(EventTreeTransferGateVertexShape, mxCylinder);
    EventTreeTransferGateVertexShape.prototype.redrawPath = (c: any, x: any, y: any, w: any, h: any) => {
      const gateSize = EventTreeTransferGateVertex.SHAPE.GATE;
      const halfSize = gateSize / 2;
      c.moveTo(w * 0.5, h - gateSize + 1);
      c.lineTo(w * 0.5 - halfSize, h);
      c.lineTo(w * 0.5 + halfSize, h);
      c.close();
      c.fillAndStroke();
      const radius = EventTreeTransferGateVertex.SHAPE.RADIUS;
      c.roundrect(0, 0, w, h - gateSize, radius, radius);
    };
    return EventTreeTransferGateVertexShape;
  }

  /**
   * @param {string} key
   * @param {EventTreeTransferGateVertexValue} value
   */
  constructor(key: string, value: EventTreeTransferGateVertexValue) {
    super(key, value);
  }

  /**
   * TODO: Implement a transfer gateTypes style and geometry
   * @override
   * @return {MxGraphType.mxGeometry}
   */
  getMyGeometry(): mxGeometry {
    return new mxGeometry(0, 0, EventTreeTransferGateVertex.SHAPE.WIDTH, EventTreeTransferGateVertex.SHAPE.HEIGHT);
  }

  getType(): string {
    return "Event Tree Transfer Gate";
  }

  /**
   * @override
   * @return {[index: string]: any}
   */
  getMyStyle(): {[index: string]: any} {
    const style: {[index: string]: any} = {};
    style[mxConstants.STYLE_SPACING] = 6;
    style[mxConstants.STYLE_FILLCOLOR] = 'rgba(151,145,68,0.2)';
    style[mxConstants.STYLE_STROKECOLOR] = 'rgba(151,149,85,0.65)';
    style[mxConstants.STYLE_FILL_OPACITY] = '50';
    style[mxConstants.STYLE_STROKE_OPACITY] = '100';
    style[mxConstants.STYLE_STROKEWIDTH] = '2';
    style[mxConstants.STYLE_FONTCOLOR] = 'inherit';
    style[mxConstants.STYLE_FONTSIZE] = '12';
    style[mxConstants.STYLE_FONTFAMILY] = 'Roboto Condensed';
    style[mxConstants.STYLE_SHAPE] = EventTreeTransferGateVertex.SHAPE_KEY;
    style[mxConstants.STYLE_SPACING_BOTTOM] = EventTreeTransferGateVertex.SHAPE.GATE;
    style[mxConstants.STYLE_WHITE_SPACE] = 'wrap';
    style[mxConstants.STYLE_AUTOSIZE] = 1;
    style[mxConstants.STYLE_RESIZABLE] = 0;
    style[mxConstants.STYLE_ASPECT] = 'fixed';
    style[mxConstants.STYLE_OVERFLOW] = 'hidden';
    return style;
  }

  clone(): EventTreeTransferGateVertex {
    return new EventTreeTransferGateVertex(null, this.value.clone());
  }
}

export default EventTreeTransferGateVertex;
